import { BaseModel } from './base-model';
import { Contact } from './contact';

export class AssessmentDistributionSurvey {
  dueDate: Date;
  threats: number;
  threatsCompleted: number;
  questions: number;
  estimatedTimeSec: number;
  target: BaseModel;
  contact: Contact;

  constructor() {
  }
}
